namespace RioErp.Web.Enums {
    export enum PaymentType {
        FromWallet = 1,
        Prepaid = 2,
        Website = 3,
        Postpaid = 4
    }
    Serenity.Decorators.registerEnumType(PaymentType, 'RioErp.Web.Enums.PaymentType');
}
